

class EventDetailMapViewController extends MUIViewController
{

    private _event:DLEvent = null;

    viewDidLoad()
    {
        super.viewDidLoad();

        // Mock map rendering removed: it depended on map/mapping.ts and map/sampledata.ts,
        // which no longer exist (MapItemsMock, createLocationCategory, MapBackgroundFactory, ...).
    }

    set event(value)
    {
        this._event = value;
        this.updateUI();
    }

    private updateUI()
    {
        if(this.viewIsLoaded && this._event != null)
        {

        }
    }
}